import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "श्री. अतुल नत्थुजी जीवतोडे ", designation: "ग्रामपंचायत  आवळगांव ", phone: "+91 9604959253", imageUrl: "/images/atul.jpeg" },
  { name: "श्री. भास्कर मणिराम बानबले", designation: "ग्रामपंचायत  आवळगांव", phone: "+91 9011156229", imageUrl: "/images/bhaskar.jpeg" },
  { name: "श्री. अश्वजीत दौलत जनबंधू", designation: "ग्रामपंचायत  आवळगांव", phone: "+91 9822886900", imageUrl: "/images/aswajit.jpeg" },
  { name: "सौ. तिल्लोत्तमा संतोष शेंडे", designation: "ग्रामपंचायत  आवळगांव", phone: "+91 749869904", imageUrl: "/images/tilo.jpg" },
  { name: "सौ. अर्चना राजेश्वर चिलबुले", designation: " ग्रामपंचायत  आवळगांव ", phone: "+91 9517643294", imageUrl: "/images/archana.jpg" },
  { name: "सौ. शामलता पुरुषोत्तम खेवले", designation: "ग्रामपंचायत  आवळगांव", phone: "+91 7743931460", imageUrl: "/images/shamlata.jpg" },
  { name: "सौ. खुनिता रवींद्र तिवडे", designation: "ग्रामपंचायत  आवळगांव", phone: "+91 --", imageUrl: "/images/khunita.jpg" },
  { name: "सौ. गीता कुसुमाकर लांजेवार", designation: "ग्रामपंचायत  आवळगांव", phone: "+91 9527670826", imageUrl: "/images/gita.jpg" },
  { name: "सौ. आशा उद्धव भोयर", designation: "ग्रामपंचायत  आवळगांव", phone: "+91 9689672691", imageUrl: "/images/asha.jpg" },

];

const karmachariMembers = [
  { name: " श्री. सरद  यादव म्हस्के  ", designation: "सफाई  कर्मचारी", imageUrl: "/images/sharad.jpeg" },
  { name: "श्री. पुरूषोत्तम पत्रूजी नरुले  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/puru.jpeg" },
  { name: "श्री.निखिल नीलकंठ नरुले", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/nikhil.jpeg" },
  { name: "श्री.प्रितम आनंदराव उंदिरवाडे", designation: "संगणक परिचालक", imageUrl: "/images/pritam.jpeg" },
  { name: "श्री.अजय रवींद्र तिवाडे", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/ajay.jpeg" },
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">कर्मचारी</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
